import CommonFields from './common_fields'
import LocalizableFields from './localizable_fields'
import StandardFields from './standard_fields'
import AssignedCategories from './categories/assigned_categories'
import useScrollToAnchor from '../../hooks/use_scroll_to_anchor'

const AllFields = ({ asset, airlineID, cycleID }) => {
  useScrollToAnchor()
  const isAd = asset?.asset_type === 'ad'
  const isChildAsset = !!asset?.parent_asset_type
  return (
    <>
      <StandardFields asset={asset} cycleID={cycleID} />
      {!isAd && <LocalizableFields assetID={asset.id} airlineID={airlineID} cycleID={cycleID} />}
      {!isAd && <p className='font-semibold h-6 my-4'>Non-localized</p>}
      <CommonFields assetID={asset.id} cycleID={cycleID} />

      {!isAd && (!isChildAsset || asset?.asset_type === 'episode') && (
        <AssignedCategories
          availableCategories={asset.available_categories}
          availablePreroll={asset.available_preroll}
          availableWarningSlates={asset.available_warning_slates}
          categories={asset.categories}
          assetID={asset.id}
          assetType={asset.asset_type}
          cycleID={cycleID}
          issue={asset.asset_issues.find((issue) => issue.validator_group === 'category')}
          isWarningSlate={asset?.is_warning_slate}
          isPrerollAd={asset?.is_preroll_ad}
        />
      )}
    </>
  )
}

export default AllFields
